import { inject, Injectable } from '@angular/core';
import { AmplitudeService } from '@brighthub/logging';

/**
 * Amplitude events for Home Open Actions. Ken asked for List vs Timeline
 * usage; `view` is a closed enum only — no action ids, client identifiers,
 * or search text.
 */
@Injectable({ providedIn: 'root' })
export class OpenActionsAnalytics {
  private readonly _amplitude = inject(AmplitudeService);

  /**
   * FA landed on or switched to a Home Open Actions view.
   *
   * @param view - `list` or `timeline`.
   */
  viewSelected(view: 'list' | 'timeline'): void {
    this._amplitude.logEvent('open_actions_view_selected', {
      view,
      app: 'brightnav',
    });
  }
}
